import React from 'react';
import { Route } from 'react-router-dom';
import { RouteWithLayout } from '../RouteWithLayout';
import { Can } from './Can';

export const CanRoute = (props: {
  component: any,
  role?: string | string[],
  permission?: string | string[],
  layout?: any,
  path?: string,
  fail?: any,
  exact?: boolean,
}) => {
  const { layout } = props;
  const fail: any = (props.fail && layout)? () => (<props.layout><props.fail {...props} /></props.layout>) : props.fail;

  return (
    <Can {...props} fail={fail}>
      {layout && (<RouteWithLayout layout={layout} {...props} />)}
      {!layout && <Route {...props}/>}
    </Can>
  );
};

export default CanRoute;
